module.exports = __webpack_public_path__ + "img/stock2.30df58b5.png";